export default ({ request }) => ({
  sysRoleListApi(data = {}) {
    return request({
      url: '/sys/role/list',
      method: 'post',
      data,
    })
  },
  sysRoleDelApi(data = {}) {
    return request({
      url: '/sys/role/del',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sysRoleRecoveryApi(data = {}) {
    return request({
      url: '/sys/role/recovery',
      method: 'post',
      data,
    })
  },
  sysRoleDetailApi(data = {}) {
    return request({
      url: '/sys/role/detail',
      method: 'post',
      data,
    })
  },
  sysRoleSaveApi(data = {}) {
    return request({
      url: '/sys/role/save',
      method: 'post',
      timeout: 60000,
      data,
    })
  },
  sysRoleCopyApi(data = {}) {
    return request({
      url: '/sys/role/copy',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sysRoleTreeApi(data = {}) {
    return request({
      url: '/sys/role/roleFunctionTree',
      method: 'post',
      data,
    })
  },
  merchantRoleUserListApi(data = {}) {
    return request({
      url: '/sys/merchant/role/user/list',
      method: 'post',
      data,
    })
  },
  merchantRoleUserSaveApi(data = {}) {
    return request({
      url: '/sys/merchant/role/user/save',
      method: 'post',
      data,
    })
  },
  merchantRoleUserOptionsApi(data = {}) {
    return request({
      url: '/sys/merchant/role/user/options',
      method: 'post',
      data,
    })
  },
  merchantRoleUserAddApi(data = {}) {
    return request({
      url: '/sys/merchant/role/user/add',
      method: 'post',
      data,
    })
  },
  merchantRoleUserDelApi(data = {}) {
    return request({
      url: '/sys/merchant/role/user/del',
      method: 'post',
      data,
    })
  },
  merchantRoleUserClearApi(data = {}) {
    return request({
      url: '/sys/merchant/role/user/clear',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
})
